export default () => {
  return (
    <div className="no-content-tips-wrapper">
      <div className="no-content-tips">No Content, please add.</div>
    </div>
  );
};
